import "@/App.css";
import "@/styles/hero.css";
import "@/styles/operations.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Hero from "@/components/Hero";
import MarqueeStack from "@/components/MarqueeStack";
import OperationsLayer from "@/components/OperationsLayer";
import IntegrationLayer from "@/components/IntegrationLayer";
import PerformanceLayer from "@/components/PerformanceLayer";
import TerminalLayer from "@/components/TerminalLayer";
import FAQ from "@/components/FAQ";
import ImprintPage from "@/components/ImprintPage";
import PrivacyPolicy from "@/components/PrivacyPolicy";
import TermsOfService from "@/components/TermsOfService";
import { LangProvider, useLang } from "@/lib/LangContext";

/* Inner consumer — extracts global language state and mounts the five
 * page layers flush. No wrapper HTML / no structural CSS added.
 * Pages 4–5 share an obsidian carrier matching the bottom of Page 3's
 * gradient (#0A1520) so the vertical scroll has zero visible seam. */
const Page = () => {
  const { lang } = useLang();
  return (
    <>
      <Hero />
      <MarqueeStack />
      <OperationsLayer />
      <IntegrationLayer language={lang} />
      <div style={{ background: "#0A1520" }}>
        <PerformanceLayer language={lang} />
        <FAQ />
        <TerminalLayer language={lang} />
      </div>
    </>
  );
};

function App() {
  return (
    <div className="App overflow-x-hidden" data-testid="app-root">
      <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Page />} />
            <Route path="/imprint" element={<ImprintPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
          </Routes>
        </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
